// UI
import BackButton from '@components/back-button';

// images
import LogoImg from '@assets/logo.png';

// styles
import css from './styles.module.css';

function ResetPassword() {
  return (
    <main className={css.resetPasswordRoot}>
      <div className={css.content}>
        <BackButton className={css.backButton} iconClassname={css.backIcon} />

        <img src={LogoImg} alt="logo" className={css.logo} />
        <h1 className={css.title}>
          We've pushed a password reset link your way ⚡
        </h1>
        <p className={css.subtitle}>
          Email with instructions was sent to your email address. Please check
          it!
        </p>
      </div>
    </main>
  );
}

export default ResetPassword;
